module.exports = __webpack_public_path__ + "static/media/nature-secondary.4812b9e8.jpg";